module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"dialogTitle":"Personalizza la tua stampa","itemAddedToBasket":"Hai aggiunto il prodotto nel tuo carrello!"},"en":{"dialogTitle":"Personalize your print","itemAddedToBasket":"You\u0027ve successfully added this item to your shopping cart!"}}')
  delete Component.options._Ctor
}
